import { globalDef } from "../siteDefinitions";

/**
 * Ajax request to the server to check if the fundraiser name exists
 */
export function fundraiserExists(fundraiserName: string): Promise<{ exists: string }> {
    return new Promise<{ exists: string }>((resolve, reject) => {
        $.ajax({
            url: `${globalDef.ajaxFunctionsUrl}function=fundraiser-exists`,
            cache: false,
            type: "POST",
            data: {
                fundraiserName,
            },
            success(response) {
                const jsonResp = JSON.parse(response);
                resolve(jsonResp);
            },
            error(error) {
                reject(error);
            },
        });
    });
}
